import i18n from '@/plugins/i18n';
const hardwareOraGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.cpuUsage'),
      header: {
        title: i18n.global.t('dbm.cpuUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_db_cpu_usage_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentage'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.percentage'),
      },
      show: true,
      showForSingleSeries: true,
    },

    {
      width: '48%',
      title: i18n.global.t('dbm.memoryUsage'),
      header: {
        title: i18n.global.t('dbm.memoryUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_memory_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'MB',
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.network-disk-usage'),
      header: {
        title: i18n.global.t('dbm.network-i-o-disk-usage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_network_io_megabytes_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      aggregation: '/',
      aggregationNum: '100',
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.mb-second'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.network-i-o-disk-request'),
      header: {
        title: i18n.global.t('dbm.network-i-o-disk-request'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_network_io_requests_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.request-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.request-second'),
      },
      showLegendForSeries: true,
    },
  ],
  cardComponents: {
    width: '46.3%',
    cardName: [
      i18n.global.t('dbm.card.osType'),
      i18n.global.t('dbm.architecture'),
      i18n.global.t('dbm.card.hostName'),
      i18n.global.t('dbm.card.availability'),
    ],
  },
  StorageCardComponents: {
    storageCards: [
      {
        label: i18n.global.t('dbm.card.cpuStorage'),
        width: '46.3%',
        show: true,
      },
      {
        label: i18n.global.t('dbm.card.memoryStorageinMB'),
        width: '46.3%',
        show: true,
      },
    ],
  },
});
export default hardwareOraGraphs;
